<app-header></app-header>

<div class="container-fluid">
    <div class="row">
        <app-breadcrumb [childLink]="childLinkLabel" [subchildLink]="subchildLinkLabel"></app-breadcrumb>
    </div>
    <div class="row">
        <div class="col-12" style="text-align: center;">
            <h2>Page is under maintenance</h2>
        </div>
    </div>
    <div class="image-container">
        <img src="../../../assets/images/Under-Maintenance.png">
    </div>
</div>